class HeaderDetail {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("alpinePage", () => ({
                    showMenu: false,
                    throttle: false,
                    header: null,
                    anchorTop: null,
                    menuIntersect: null,
                    menu: null,
                    menuLaptop: null,
                    detailSections: [],

                    lastScroll: 0,

                    init() {
                        this.scrollHandler();
                    },
                    scrollHandler() {
                        this.header = document.querySelector(
                            "header:first-of-type",
                        );
                        this.menuIntersect = document.querySelector(
                            "[data-intersect-menu]",
                        );
                        this.menu = document.querySelector("#detail_menu");

                        this.detailSections = Array.from(
                            document.querySelectorAll(
                                "[data-intersect-detail]",
                            ),
                        ).reverse();

                        this.anchorTop = document.querySelector("#anchor_top");

                        this.headingHandler();
                        window.addEventListener("scroll", () =>
                            this.throttleHandler(),
                        );
                    },
                    throttleHandler() {
                        if (this.throttle) {
                            return;
                        }

                        this.headingHandler();
                        this.lastScroll = window.scrollY;
                        this.throttle = true;

                        setTimeout(() => {
                            this.throttle = false;
                            if (this.lastScroll !== window.scrollY) {
                                this.throttleHandler();
                            }
                        }, 250);
                    },
                    headingHandler() {
                        const headerHeight = this.header.clientHeight ?? 0;

                        let menuHeight = 0;

                        if (this.checkVisibilityFallback(this.getMenuLaptop)) {
                            menuHeight = this.menu.clientHeight ?? 0;
                        }

                        // anchor top
                        if (window.scrollY === 0) {
                            this.anchorTop.dataset.hidden = true;
                        } else {
                            delete this.anchorTop.dataset.hidden;
                        }

                        // menu
                        const menuTargetRect =
                            this.menuIntersect.getBoundingClientRect();
                        this.showMenu = menuTargetRect.top <= headerHeight;

                        // header list scroll
                        for (const section of this.detailSections) {
                            const targetRect = section.getBoundingClientRect();
                            if (targetRect.top <= headerHeight + menuHeight) {
                                if (section.dataset.end) {
                                    this.showMenu = false;
                                    return;
                                }

                                this.showMenu = section.dataset.intersectDetail;
                                return;
                            }
                        }
                    },

                    scrollToElement(id) {
                        const element = document.querySelector(
                            `[x-ref='${id}']`,
                        );

                        if (!element) {
                            return;
                        }

                        const headerHeight = this.header.clientHeight ?? 0;
                        const { top } = element.getBoundingClientRect();
                        let topScroll = window.scrollY + top - headerHeight;

                        if (this.checkVisibilityFallback(this.getMenuLaptop)) {
                            topScroll -= this.menu.clientHeight ?? 0;
                        }

                        window.scrollTo({
                            top: topScroll + 1, // Leeway
                            behavior: "smooth",
                        });
                    },

                    checkVisibilityFallback(el) {
                        if (!el) return false;

                        const style = window.getComputedStyle(el);

                        return !(
                            style.display === "none" ||
                            style.visibility === "hidden" ||
                            style.opacity === "0"
                        );
                    },

                    get getMenuLaptop() {
                        if (!this.menuLaptop) {
                            this.menuLaptop = document.querySelector(
                                "#detail_menu_laptop",
                            );
                        }
                        return this.menuLaptop;
                    },
                }));
            },
            { once: true },
        );
    }
}

new HeaderDetail();
